import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/offenses")({
  loader: () => ({ crumb: "Offenses" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
